import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useRegisterPage } from "../../hooks/useRegisterPage";

// import {mainlogo} from "../../src/assets/images";

import "../../assets/styles/common-styles.scss";
import { NavLink } from "react-router-dom";
import FormLayout from "../FormLayout";
import { userRegistrationSchema } from "../../config/schemas/registerSchema";
import { useSnackbar } from "../../hooks/useSnackbar";
import DynamicForm from "../../components/common/DynamicForm";
import useRegisterFields from "./useRegisterFields";

const RegisterPage: React.FunctionComponent<any> = () => {
  type FormData = z.infer<typeof userRegistrationSchema>;
  const { showSuccess, handleError } = useSnackbar();
  const {registerFields} = useRegisterFields()

  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      confirmPassword: "",
      number: undefined,
    },
    resolver: zodResolver(userRegistrationSchema),
  });

  const {
    registerUser,
    registerUserIsSuccess,
    registerUserData,
    registerUserIsError,
    registerUserErrorData,
  } = useRegisterPage();

  const handleRegisterUser = (response: FormData) => {
    registerUser({
      data: {
        first_name: response.first_name,
        last_name: response.last_name,
        email: response.email,
        password: response.password,
        office_number: 0,
      },
    });
  };

  useEffect(() => {
    if (registerUserIsSuccess) {
      showSuccess(registerUserData?.details,'user-register-success');
      reset();
    }
  }, [registerUserIsSuccess]);

  useEffect(() => {
    if (registerUserIsError) {
      const errorMsg: any = registerUserErrorData;
      handleError(errorMsg);
    }
  }, [registerUserIsError]);

  const onInvalid = (errors: any) => console.debug(errors);
  return (
    <FormLayout title="Register">
      <Box>
        <form onSubmit={handleSubmit(handleRegisterUser, onInvalid)}>
          <DynamicForm
            fieldsJson={registerFields}
            errors={errors}
            register={register}
            control={control}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            size="large"
            className="formLoginBtn"
            id="Register"
          >
            Register
          </Button>
        </form>
        <Grid container justifyContent="center">
          <Grid item>
            <NavLink to="/login">Already have an account? Sign in</NavLink>
          </Grid>
        </Grid>
      </Box>
    </FormLayout>
  );
};

export default RegisterPage;
